<div [ngClass]="'question__list-style_' + question.param.listStyle" *ngIf="!questionSession.doneAt">
    <ng-container *ngIf="!isRadio">
        <label for="checkbox{{i}}" class="choice checkbox__container"
            *ngFor="let choice of internalQuestionSession?.answer.choices; let i = index"
            [ngClass]="{'choice_selected': choice.state}">
            <span class="choice__text">{{choice.choice}}</span>
            <label for="checkbox{{i}}" class="templab-checkbox">
                <input type="checkbox" class="templab-checkbox__input" id="checkbox{{i}}" name="choice{{choice.choice}}"
                    [(ngModel)]="choice.state" (change)="onChange()">
                <span class="templab-checkbox__checkmark"></span>
            </label>
        </label>
    </ng-container>
    <ng-container *ngIf="isRadio">
        <label for="radio{{i}}" class="choice"
            *ngFor="let choice of internalQuestionSession?.answer.choices; let i = index"
            [ngClass]="{'choice_selected': choice.state}">
            <span class="choice__text">{{choice.choice}}</span>
            <label for="radio{{i}}" class="input">
                <input type="radio" class="input-radiobox" id="radio{{i}}" name="radio" [checked]="choice.state"
                    (change)="singleSelect(choice)">
            </label>
        </label>
    </ng-container>
</div>

<div class="" *ngIf="questionSession.doneAt">
    <div class="flex items-center justify-between mb-4 m-actions" *ngIf="!questionSession.isCorrect">
        <div class="m-switch inline-flex bg-[#F6F7F9] rounded-full p-1">
            <button type="button"
                class="m-switch-item px-4 py-1.5 rounded-full text-sm font-semibold transition-colors"
                [ngClass]="!solution ? 'item--active text-white' : 'text-[#5F6877]'"
                [style.background]="!solution ? 'hsl(var(--primary))' : ''"
                (click)="changeTab()">
                <span>{{ 'words.my-answer' | translate }}</span>
            </button>

            <button type="button"
                class="m-switch-item px-4 py-1.5 rounded-full text-sm font-semibold transition-colors"
                [ngClass]="solution ? 'item--active text-white' : 'text-[#5F6877]'"
                [style.background]="solution ? 'hsl(var(--primary))' : ''"
                (click)="changeTab()">
                <span>{{ 'words.solution' | translate }}</span>
            </button>
        </div>

        <div class=" m-ratio">
            <span class=" text-xs  text-gray-700 font-normal tracking-wide">{{ 'words.result' | translate | uppercase }}: </span>
            <span class=" text-sm font-semibold" style="color: var(--secondary-600);">{{questionSession.ratio}}%</span>
        </div>
    </div>

    <div class="m-flex" *ngFor="let answer of questionSession.answer.choices; let index=index;">
        <div class="m-answer m-items-center" style="display: flex; width: 100%; justify-content: space-between;"
            [ngClass]="{
                'm-answer--correct': questionSession.question?.content?.choices[index]?.state && (solution || answer.state),
                'm-answer--wrong': !solution && answer.state && !questionSession.question?.content?.choices[index]?.state
            }">
            <span>{{ answer.choice }}</span>

            <!-- Opción correcta (en Solución, o en Mi respuesta si fue la seleccionada): check verde -->
            <ng-container *ngIf="questionSession.question?.content?.choices[index]?.state && (solution || answer.state); else wrongOrDefaultIcon">
                <span class="w-[18px] h-[18px] rounded-full flex items-center justify-center flex-shrink-0"
                    style="background: rgb(16, 185, 129);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
                        class="w-3 h-3 text-white">
                        <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                </span>
            </ng-container>

            <ng-template #wrongOrDefaultIcon>
                <!-- Selección incorrecta del alumno: x roja -->
                <ng-container *ngIf="!solution && answer.state && !questionSession.question?.content?.choices[index]?.state; else defaultChoiceInput">
                    <span class="w-[18px] h-[18px] rounded-full flex items-center justify-center flex-shrink-0"
                        style="background: #e21d48;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
                            class="w-3 h-3 text-white">
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                        </svg>
                    </span>
                </ng-container>
            </ng-template>

            <!-- Opción no seleccionada ni destacada: input deshabilitado normal -->
            <ng-template #defaultChoiceInput>
                <label style="display: flex; align-items: center; margin: 0;">
                    <input type="checkbox" *ngIf="!isRadio" style="height: 18px; width: 18px; margin: 0;"
                        [ngModel]="!solution ? answer.state : questionSession.question?.content?.choices[index]?.state"
                        disabled>
                    <input type="radio" *ngIf="isRadio" style="height: 18px; width: 18px; margin: 0;"
                        [checked]="!solution ? answer.state : questionSession.question?.content?.choices[index]?.state"
                        disabled>
                </label>
            </ng-template>
        </div>
    </div>
</div>

<app-timer [timerService]="timerService" (close)="timerInit()"></app-timer>